import { useMutation } from "react-query";
import {
  fetchBonusIndex,
  fetchBrandLogoList,
  fetchCreatorRecent,
  fetchFreeShipping,
  fetchHomeAdInfo,
  fetchHomeAdv,
  fetchHomeBanner,
  fetchHomeOverview,
  fetchHomeProductRecommend,
  fetchHomeProductRecommendV3,
  fetchHomeRankingProduct,
  fetchProductRecommend,
  fetchProductSearch,
  fetchRankProduct,
  fetchSearchConfig,
  fetchSetting,
} from ".";

export const useHomeBanner = () => useMutation(fetchHomeBanner);

export const useSearchConfig = () => useMutation(fetchSearchConfig);

export const useProductSearch = () => useMutation(fetchProductSearch);

export const useProductRecommend = () => useMutation(fetchProductRecommend);

export const useRankProduct = () => useMutation(fetchRankProduct);

export const useBrandLogoList = () => useMutation(fetchBrandLogoList);

export const useBonusIndex = () => useMutation(fetchBonusIndex);

export const useFreeShipping = () => useMutation(fetchFreeShipping);

export const useCreatorRecent = () => useMutation(fetchCreatorRecent);

export const useSetting = () => useMutation(fetchSetting);

export const useHomeProductRecommend = () =>
  useMutation(fetchHomeProductRecommend);

export const useHomeRankingProduct = () => useMutation(fetchHomeRankingProduct);

export const useHomeOverview = () => useMutation(fetchHomeOverview);

export const useHomeAdv = () => useMutation(fetchHomeAdv);

export const useHomeAdInfo = () => useMutation(fetchHomeAdInfo);

export const useHomeProductRecommendV3 = () =>
  useMutation(fetchHomeProductRecommendV3);
